import styled from 'styled-components';
import { THEME } from '../../../../themes';

export const Container = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: ${THEME.SPACING.LOOSE} ${THEME.SPACING.MEDIUM};
  margin-top: ${THEME.SPACING.MEDIUM};
`;
